import { render, staticRenderFns } from "./TipPop.vue?vue&type=template&id=b8cd1f38&scoped=true"
import script from "./TipPop.vue?vue&type=script&lang=js"
export * from "./TipPop.vue?vue&type=script&lang=js"
import style0 from "./TipPop.vue?vue&type=style&index=0&id=b8cd1f38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cd1f38",
  null
  
)

export default component.exports